/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'components/select';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';

const Redundancy = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setRedundancy = (redundancy, redundancyDetail) => {
        setOrder({ ...order, redundancy, redundancyDetail });
    };
    const redundancyApi = useMutation(() => axios.get(`${endPoints.ssp.day2OperationPass.redundancy}`));
    const seldValueExistsInOptions = (redundancyValue) => options.find((option) => redundancyValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setRedundancy(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        if (redundancyApi?.isSuccess) {
            if (redundancyApi?.data?.data) setOptions(redundancyApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [redundancyApi?.isSuccess]);

    React.useEffect(() => {
        redundancyApi.mutate();
    }, []);
    React.useEffect(() => {
        if (!order?.redundancy && order?.isTouched) setIsTouched(true);
    }, [order?.redundancy, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="redundancy"
                label="Redundancy *"
                value={order?.redundancy || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={redundancyApi.isLoading}
                isLoading={redundancyApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(Redundancy);
